import { render, staticRenderFns } from "./businessEndorsement.vue?vue&type=template&id=273fd14e&scoped=true&"
import script from "./businessEndorsement.vue?vue&type=script&lang=js&"
export * from "./businessEndorsement.vue?vue&type=script&lang=js&"
import style0 from "./businessEndorsement.vue?vue&type=style&index=0&id=273fd14e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273fd14e",
  null
  
)

export default component.exports